module.exports = {
     development: "https://lyfapi-meidian.leyinfupay.cn:",  // 新正式
    production: "https://lyfapi-meidian.leyinfupay.cn:"
    // production: "https://test.leyinfupay.cn:", //测试
    // development: "https://test.leyinfupay.cn:",
};
// 发起进件 -- 签约 -- 后五个接口



// WEBPACK FOOTER //
// ./src/common/conf/Server.js